import React from 'react';

const Description = () => (
    <section className="desc">
        <div className="desc__contact">
            <div className="desc__tel">0 22 41/ 97 39 980</div>
            <div className="desc__tel-times">
                Hilfe vom Anwalt  - kostenfreier Erstkontakt<br />
            </div>
        </div>
        <div className="desc__teaser">
            <p>
                Sie haben eine <span className="highlighted">Kündigung</span> Ihres &nbsp;
                <span className="highlighted">Arbeitsverhältnisses</span> erhalten und sind
                unsicher, ob es sich lohnt <span className="highlighted">dagegen vorzugehen?</span>
            </p>
        </div>
        <div>
            Finden Sie es hier mit nur wenigen Fragen heraus.
        </div>
    </section>
);

export default Description;



// WEBPACK FOOTER //
// ./src/components/partial.description.js